var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react": () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e("vendors-node_modules_react_index_js").then(() => (() => (__webpack_require__(/*! react */ "./node_modules/react/index.js"))))))),
	"webpack/sharing/consume/default/@azure/msal-browser/@azure/msal-browser": () => (loadStrictVersion("default", "@azure/msal-browser", false, [1,4,27,0], () => (__webpack_require__.e("vendors-node_modules_azure_msal-browser_dist_index_mjs").then(() => (() => (__webpack_require__(/*! @azure/msal-browser */ "./node_modules/@azure/msal-browser/dist/index.mjs"))))))),
	"webpack/sharing/consume/default/react-dom/react-dom": () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e("vendors-node_modules_react-dom_index_js").then(() => (() => (__webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js"))))))),
	"webpack/sharing/consume/default/@emotion/react/@emotion/react?9138": () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,0,0,,"rc",0], () => (__webpack_require__.e("vendors-node_modules_emotion_react_dist_emotion-react_browser_development_esm_js").then(() => (() => (__webpack_require__(/*! @emotion/react */ "./node_modules/@emotion/react/dist/emotion-react.browser.development.esm.js"))))))),
	"webpack/sharing/consume/default/@emotion/react/@emotion/react?a5be": () => (loadSingletonVersion("default", "@emotion/react", false, [1,11,4,1], () => (__webpack_require__.e("vendors-node_modules_emotion_react_dist_emotion-react_browser_development_esm_js").then(() => (() => (__webpack_require__(/*! @emotion/react */ "./node_modules/@emotion/react/dist/emotion-react.browser.development.esm.js"))))))),
	"webpack/sharing/consume/default/@mui/material/@mui/material": () => (loadStrictVersion("default", "@mui/material", false, [1,7,3,7], () => (Promise.all([__webpack_require__.e("vendors-node_modules_mui_material_esm_MenuItem_MenuItem_js"), __webpack_require__.e("vendors-node_modules_mui_material_esm_IconButton_IconButton_js"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Switch_Switch_js-node_modules_mui_material_esm_Tooltip_-412fb7"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Checkbox_Checkbox_js-node_modules_mui_material_esm_Chip-66eb5d"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Grid_Grid_js"), __webpack_require__.e("vendors-node_modules_mui_material_esm_LinearProgress_LinearProgress_js-node_modules_mui_mater-e6c60a"), __webpack_require__.e("vendors-node_modules_mui_material_esm_ClickAwayListener_ClickAwayListener_js-node_modules_mui-924d2a"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Snackbar_Snackbar_js"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Autocomplete_Autocomplete_js-node_modules_mui_material_-184cb4"), __webpack_require__.e("vendors-node_modules_mui_material_esm_AppBar_AppBar_js-node_modules_mui_material_esm_Card_Car-a48a91"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Dialog_Dialog_js-node_modules_mui_material_esm_DialogAc-5cf0d9"), __webpack_require__.e("vendors-node_modules_mui_material_esm_index_js")]).then(() => (() => (__webpack_require__(/*! @mui/material */ "./node_modules/@mui/material/esm/index.js"))))))),
	"webpack/sharing/consume/default/date-fns/date-fns": () => (loadStrictVersion("default", "date-fns", false, [1,4,1,0], () => (__webpack_require__.e("vendors-node_modules_date-fns_index_js").then(() => (() => (__webpack_require__(/*! date-fns */ "./node_modules/date-fns/index.js"))))))),
	"webpack/sharing/consume/default/react-router-dom/react-router-dom": () => (loadStrictVersion("default", "react-router-dom", false, [1,7,11,0], () => (__webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_mjs").then(() => (() => (__webpack_require__(/*! react-router-dom */ "./node_modules/react-router-dom/dist/index.mjs"))))))),
	"webpack/sharing/consume/default/@mui/x-data-grid/@mui/x-data-grid": () => (loadStrictVersion("default", "@mui/x-data-grid", false, [1,8,22,1], () => (Promise.all([__webpack_require__.e("vendors-node_modules_mui_material_esm_Switch_Switch_js-node_modules_mui_material_esm_Tooltip_-412fb7"), __webpack_require__.e("vendors-node_modules_mui_material_esm_LinearProgress_LinearProgress_js-node_modules_mui_mater-e6c60a"), __webpack_require__.e("vendors-node_modules_mui_material_esm_Autocomplete_Autocomplete_js-node_modules_mui_material_-184cb4"), __webpack_require__.e("vendors-node_modules_mui_x-data-grid_esm_index_js")]).then(() => (() => (__webpack_require__(/*! @mui/x-data-grid */ "./node_modules/@mui/x-data-grid/esm/index.js"))))))),
	"webpack/sharing/consume/default/uuid/uuid": () => (loadStrictVersion("default", "uuid", false, [1,13,0,0], () => (__webpack_require__.e("vendors-application_node_modules_uuid_dist_esm-browser_index_js").then(() => (() => (__webpack_require__(/*! uuid */ "../application/node_modules/uuid/dist/esm-browser/index.js")))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react"
	],
	"webpack_sharing_consume_default_azure_msal-browser_azure_msal-browser": [
		"webpack/sharing/consume/default/@azure/msal-browser/@azure/msal-browser"
	],
	"webpack_sharing_consume_default_react-dom_react-dom": [
		"webpack/sharing/consume/default/react-dom/react-dom"
	],
	"webpack_sharing_consume_default_emotion_react_emotion_react-webpack_sharing_consume_default_e-e499c2": [
		"webpack/sharing/consume/default/@emotion/react/@emotion/react?9138",
		"webpack/sharing/consume/default/@emotion/react/@emotion/react?a5be"
	],
	"webpack_sharing_consume_default_mui_material_mui_material": [
		"webpack/sharing/consume/default/@mui/material/@mui/material"
	],
	"webpack_sharing_consume_default_date-fns_date-fns": [
		"webpack/sharing/consume/default/date-fns/date-fns"
	],
	"webpack_sharing_consume_default_react-router-dom_react-router-dom": [
		"webpack/sharing/consume/default/react-router-dom/react-router-dom"
	],
	"src_shared_ScenarioList_shared_tsx": [
		"webpack/sharing/consume/default/@mui/x-data-grid/@mui/x-data-grid"
	],
	"src_shared_ScenarioForm_shared_tsx": [
		"webpack/sharing/consume/default/uuid/uuid"
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}